export default __webpack_public_path__ + "static/media/mainImg.96641c0b.png";